package fr.labodoc.healthProfessional.api.payloads.responses

import kotlinx.serialization.Serializable

@Serializable
data class ApplicationInformationResponse(
  val healthProfessional: HealthProfessional
) {
  @Serializable
  data class HealthProfessional(
    val nationalIdentifier: String,
    val rppsNumber: String?,
    val medicalCard: MedicalCard,
    val situations: List<Situation>
  ) {
    @Serializable
    data class MedicalCard(
      val typeCode: String,
      val typeName: String,
      val number: String
    )

    @Serializable
    data class Situation(
      val courtesyCode: String?,
      val lastName: String,
      val firstName: String,
      val healthDirectoryProfession: HealthDirectoryProfession,
      val healthDirectoryProfessionalCategory: HealthDirectoryProfessionalCategory,
      val healthDirectoryProfessionalStatus: HealthDirectoryProfessionalStatus,
      val healthDirectoryExpertise: HealthDirectoryExpertise?,
      val healthDirectoryPharmacistTableSectionCode: String?,
      val facility: Facility?,
      val labodocMatchings: List<LabodocMatching>
    ) {

      @Serializable
      data class HealthDirectoryProfession(
        val code: String,
        val name: String
      )

      @Serializable
      data class HealthDirectoryProfessionalCategory(
        val code: String,
        val name: String
      )

      @Serializable
      data class HealthDirectoryProfessionalStatus(
        val code: String,
        val name: String
      )

      @Serializable
      data class HealthDirectoryExpertise(
        val code: String,
        val name: String
      )

      @Serializable
      data class Facility(
        val name: String?,
        val officeCedex: String,
        val departmentCode: String
      )

      @Serializable
      data class LabodocMatching(
        val medicalProfession: MedicalProfession,
        val medicalSpeciality: MedicalSpeciality,
        val medicalInterests: List<MedicalInterest>
      ) {
        @Serializable
        data class MedicalProfession(
          val id: String,
          val name: String
        )

        @Serializable
        data class MedicalSpeciality(
          val id: String,
          val name: String
        )

        @Serializable
        data class MedicalInterest(
          val id: String,
          val name: String
        )
      }
    }
  }
}
